import { Phone, Mail, MapPin } from "lucide-react";
import { Link } from "react-router-dom";
import { AGENCY } from "@/data/content";
import { useQuote } from "@/context/QuoteContext";

export default function Footer() {
  const { openQuote } = useQuote();
  return (
    <footer className="bg-brand-ink text-brand-cream">
      {/* CTA band */}
      <div className="border-b border-brand-cream/15">
        <div className="mx-auto max-w-7xl px-5 sm:px-8 py-16 flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
          <h2 className="font-serif text-4xl sm:text-5xl max-w-xl leading-tight">
            Ready for coverage that <span className="italic text-brand-sand">actually fits?</span>
          </h2>
          <div className="flex flex-wrap gap-4">
            <button onClick={() => openQuote()} data-testid="footer-quote-btn"
              className="rounded-full bg-brand-clay text-white font-medium px-8 py-4 hover:bg-[#9e4c3e] active:scale-95 transition-all">
              Get a Free Quote
            </button>
            <a href={AGENCY.phoneHref} data-testid="footer-call-btn"
              className="rounded-full border border-brand-cream/40 font-medium px-8 py-4 flex items-center gap-2 hover:bg-brand-cream/10 transition-colors">
              <Phone className="h-4 w-4" /> {AGENCY.phone}
            </a>
          </div>
        </div>
      </div>

      <div className="mx-auto max-w-7xl px-5 sm:px-8 py-14 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2.5">
            <span className="grid h-9 w-9 place-items-center rounded-full bg-brand-sand text-brand-ink font-serif text-lg shrink-0">D</span>
            <div className="leading-tight">
              <span className="block font-serif text-xl">{AGENCY.name}</span>
              <span className="block font-mono text-[10px] uppercase tracking-[0.14em] text-brand-cream/55 mt-0.5">{AGENCY.legalName}</span>
            </div>
          </div>
          <p className="mt-4 text-brand-cream/60 text-sm max-w-sm leading-relaxed">
            An independent insurance agency serving Baton Rouge and greater Louisiana with auto, home, life, and commercial coverage.
          </p>
          <div className="mt-5 space-y-2 text-sm text-brand-cream/70">
            <a href={`https://maps.google.com/?q=${AGENCY.addressMapQuery}`} target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-brand-sand"><MapPin className="h-4 w-4" /> {AGENCY.address}</a>
            <a href={AGENCY.phoneHref} className="flex items-center gap-2 hover:text-brand-sand"><Phone className="h-4 w-4" /> {AGENCY.phone}</a>
            <a href={`mailto:${AGENCY.email}`} className="flex items-center gap-2 hover:text-brand-sand"><Mail className="h-4 w-4" /> {AGENCY.email}</a>
          </div>
        </div>

        <div>
          <div className="overline text-brand-sand">Coverage</div>
          <ul className="mt-4 space-y-2 text-sm text-brand-cream/70">
            <li><a href="#products" className="hover:text-brand-sand">Auto Insurance</a></li>
            <li><a href="#products" className="hover:text-brand-sand">Home Insurance</a></li>
            <li><a href="#products" className="hover:text-brand-sand">Life Insurance</a></li>
            <li><a href="#products" className="hover:text-brand-sand">Commercial Insurance</a></li>
          </ul>
        </div>
        <div>
          <div className="overline text-brand-sand">Agency</div>
          <ul className="mt-4 space-y-2 text-sm text-brand-cream/70">
            <li><a href="#about" className="hover:text-brand-sand">About Us</a></li>
            <li><a href="#reviews" className="hover:text-brand-sand">Reviews</a></li>
            <li><a href="#service" className="hover:text-brand-sand">Client Service</a></li>
            <li><a href="#claims" className="hover:text-brand-sand">File a Claim</a></li>
            <li><Link to="/admin/login" className="hover:text-brand-sand">Agent Login</Link></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-brand-cream/15">
        <div className="mx-auto max-w-7xl px-5 sm:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-brand-cream/50">
          <span>© {new Date().getFullYear()} {AGENCY.name} · {AGENCY.legalName} · anicobr.com</span>
          <div className="flex flex-wrap items-center gap-4">
            <Link to="/privacy" data-testid="footer-privacy-link" className="hover:text-brand-sand">Privacy Policy</Link>
            <Link to="/terms" data-testid="footer-terms-link" className="hover:text-brand-sand">Terms of Service</Link>
            <span className="font-mono">{AGENCY.license} · {AGENCY.years}+ years</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
